import { create } from 'zustand';
import { AdminStats } from '../types';

interface AdminStore {
  stats: AdminStats | null;
  period: 'week' | 'month' | 'all_time';
  loading: boolean;
  error: string | null;
  setStats: (stats: AdminStats | null) => void;
  setPeriod: (period: 'week' | 'month' | 'all_time') => void;
  setLoading: (loading: boolean) => void;
  setError: (error: string | null) => void;
}

export const useAdminStore = create<AdminStore>((set) => ({
  stats: null,
  period: 'all_time',
  loading: false,
  error: null,
  setStats: (stats) => set({ stats }),
  setPeriod: (period) => set({ period }),
  setLoading: (loading) => set({ loading }),
  setError: (error) => set({ error }),
}));

